import { useMemo } from 'react'
import { Skus } from '../constants'

/**
 * Custom hook for form validation logic in the AssignLicense component
 * @param {Object} formState - Current form state from useFormState
 * @param {Object} license - License object containing product information
 * @returns {Object} Validation results and computed values
 */
const useFormValidation = (formState, netSuiteAsset) => {
  const { programCodes } = netSuiteAsset?.product || {}

  return useMemo(() => {
    const { nsCustomerId, siteName, isTosConfirmed } = formState

    const shouldIgnoreTos =
      !programCodes?.includes(Skus.MSPSkuCode) &&
      !programCodes?.includes(Skus.K8SkuCode)
    const isTosValid = shouldIgnoreTos || isTosConfirmed
    const isSiteIdSet =
      nsCustomerId !== '' || (nsCustomerId === '' && siteName !== '')

    return {
      isReadyToSubmit: isSiteIdSet && !!siteName && isTosValid,
      shouldIgnoreTos,
      isTosValid,
      isSiteIdSet,
    }
  }, [formState, programCodes])
}

export default useFormValidation
